import {
  ADD_YARN_QUALITY,
  GET_YARN_QUALITY,
  DELETE_YARN_QUALITY,
  EDIT_YARN_QUALITY,
} from ".././Types";
const initialState = {
  yarnQuality: [],
};

function clothQualityReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_YARN_QUALITY: {
      return {
        ...state,
        yarnQuality: [...state.yarnQuality, action.payload],
      };
    }
    case GET_YARN_QUALITY: {
      const totalYarnQuality = action.payload;
      return { ...state, yarnQuality: totalYarnQuality };
    }
    case EDIT_YARN_QUALITY: {
      let UpdatedyarnQuality = state.yarnQuality.map((item) =>
        item.yarn_quality_id === action.payload.yarn_quality_id
          ? action.payload
          : item
      );
      return {
        ...state,
        yarnQuality: UpdatedyarnQuality,
      };
    }
    case DELETE_YARN_QUALITY: {
      const after_delete_yarnQuality = state.yarnQuality.filter(
        (yarnQuality) =>
          yarnQuality.yarn_quality_id !== action.payload.yarn_quality_id
      );
      console.log(after_delete_yarnQuality);
      return { ...state, yarnQuality: after_delete_yarnQuality };
    }
    default:
      return state;
  }
}

export default clothQualityReducer;
